import clsx from 'clsx'

import s from '../styles.module.scss'

import { BaggageInfo } from './baggage-info'
import { FlightDetails } from './flight-details'
import { RouteInfo } from './route-info'

interface FlightSegmentData {
  route: string
  class: string
  departureTime: string
  departureCode: string
  arrivalTime: string
  arrivalCode: string
  duration: string
  transfers: string
  isNightTransfer?: boolean
  hasBaggage: boolean
  hasHandBaggage: boolean
  baggageWeight?: string
  handBaggageWeight?: string
  airLineLogo?: string
}

interface FlightSegmentProps {
  data: FlightSegmentData
}

export const FlightSegment = ({ data }: FlightSegmentProps) => {
  return (
    <div className={s.segmentCard}>
      <div className={s.segmentHeader}>
        <h6 className={clsx('bold-14', s.segmentTitle)}>{data.route}</h6>
        <span className={clsx('medium-12', s.segmentClass)}>{data.class}</span>
      </div>

      <div className={s.flightInfo}>
        <div className={s.flightInfoItem}>
          <img
            src={data.airLineLogo}
            alt="MTravel"
            className={s.airlineLogo}
          />
          <RouteInfo
            departureTime={data.departureTime}
            departureCode={data.departureCode}
            arrivalTime={data.arrivalTime}
            arrivalCode={data.arrivalCode}
          />
        </div>
        <div className={s.flightInfoItem}>
          <FlightDetails
            duration={data.duration}
            transfers={data.transfers}
            isNightTransfer={data.isNightTransfer}
          />
        </div>
      </div>

      <BaggageInfo
        hasBaggage={data.hasBaggage}
        hasHandBaggage={data.hasHandBaggage}
        baggageWeight={data.baggageWeight}
        handBaggageWeight={data.handBaggageWeight}
      />
    </div>
  )
}
